<template>
  <v-card>
    <!-- tab control -->
    <v-card class="d-flex justify-space-around align-center">
      <div bottom class="text-h5">Comisiones Pendientes</div>
    </v-card>
    <!-- tab0 list -->
    <v-card-text>
      <v-card>
        <!-- advanced filter -->
        <v-toolbar>
          <v-text-field
            disabled
            hide-details
            v-model="client.client_name"
            label="Cliente"
          >
            <v-icon
              slot="prepend"
              class="enabled-icon"
              @click="clientSearchClick"
            >
              mdi-magnify
            </v-icon>
            <!-- eslint-disable -->
            <v-icon
              slot="append-outer"
              class="enabled-icon"
              @click="clientSelected(null)"
            >
              mdi-close
            </v-icon>
            <!-- eslint-enable -->
          </v-text-field>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Comercial"
            :items="commercialPersonItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="name"
            item-value="commercial_person"
            return-object
            @change="commercialPersonSelected($event)"
            ref="commercialPersonAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('commercialPersonAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-progress-linear
            :active="loading"
            indeterminate
            absolute
            bottom
          ></v-progress-linear>
        </v-toolbar>
      </v-card>
      <div v-show="pivotLoaded" id="pivot-container" class="mt-2"></div>
    </v-card-text>

    <!-- component for magnify searchs -->
    <paginated-search-dialog
      v-if="clientShowSearch"
      :show="clientShowSearch"
      :title="clientSearchOptions.title"
      :endpoint="clientSearchOptions.endpoint"
      :ordering="clientSearchOptions.ordeting"
      :searchLabel="clientSearchOptions.searchLabel"
      :headers="clientSearchOptions.headers"
      :filterString="clientSearchOptions.filterString"
      :canEdit="false"
      :canAdd="false"
      :searchOnURL="clientSearchOptions.searchOnURL"
      @itemSelected="clientSelected($event)"
      @cancel="searchCanceled"
    >
    </paginated-search-dialog>
  </v-card>
</template>
<script>
import WebDataRocks from "webdatarocks";
import "webdatarocks/webdatarocks.min.css";
import "webdatarocks/webdatarocks.toolbar";
import wdrEs from "@/assets/webDataRocksEs.json";
import PaginatedSearchDialog from "@/components/PaginatedSearchDialog.vue";
import XLSX from "xlsx";

export default {
  name: "SaleCommission",

  components: {
    PaginatedSearchDialog
  },

  data() {
    return {
      currentLevel: -1,
      clientSearchOptions: {},
      clientShowSearch: false,
      client: {
        client_code: "",
        client_name: "",
        client_id: 0,
        dealers_quantity: 0
      },
      pivot: null,
      pivotLoaded: false,
      loading: true,
      commercialPersonItems: [],
      filterCommercialPerson: null
    };
  },

  methods: {
    //Reading data from API method.
    async readDataFromAPI() {
      try {
        this.loading = true;
        /* eslint-disable */
        if (this.client.client_id != 0 || this.filterCommercialPerson || this.currentLevel >= 2) {
          let endpoint =
            "/data/sale_commissions_report/" +
            /* eslint-disable */
            (this.client ? this.client.client_id.toString() : "0") +
            "/";
            /* eslint-disable */
            switch (this.filterCommercialPerson ? this.filterCommercialPerson.commercial_type_level : 0) {
              case 0:
                endpoint = endpoint + "0/0/0";
                break;
              case 1:
                /* eslint-disable */
                endpoint = endpoint + this.filterCommercialPerson.commercial_id.toString() + "/0/0";
                break;
              case 2:
                /* eslint-disable */
                endpoint = endpoint + "0/" + this.filterCommercialPerson.commercial_id.toString() + "/0";
                break;
              case 3:
                /* eslint-disable */
                endpoint = endpoint + "0/0/" + this.filterCommercialPerson.commercial_id.toString();
                break;
            }

          let response = await this.$bRoot.search(endpoint);

          let title =
            "Comisiones Pendientes " +
             /* eslint-disable */
             (this.client ? " cliente " + this.client.client_name : ' clientes del comercial ' + this.filterCommercialPerson.name);
          await this.loadPivotTable(response.data, title);
          this.pivotLoaded = true;
        } else {
          this.pivotLoaded = false;
          this.unloadPivotTable();
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        this.loading = false;
      }
    },

    clientSearchClick() {
      this.clientSearchOptions = {
        headers: [
          { text: "Código", value: "client_data.code", sortable: false },
          {
            text: "Identificación",
            value: "client_data.identification",
            sortable: false
          },
          { text: "Nombre", value: "client_data.name", sortable: false },
          {
            text: "Categoría",
            value: "client_data.category_object.description",
            sorteable: false
          }
        ],
        title: "Cliente...",
        endpoint: "/data/clients_hierarchy/0",
        ordering: null,
        searchLabel: "Código/CUIT/Nombre",
        filterString: null,
        selected: "clientSelected",
        searchOnURL: true
      };
      this.clientShowSearch = true;
    },

    async clientSelected(client) {
      if (client) {
        this.clearAutocomplete("commercialPersonAutocomplete");
        this.client = {
          client_code: client.client_data.code,
          client_name: client.client_data.name,
          client_id: client.client_data.id,
          dealers_quantity: client.dealers_quantity
        };
        await this.readDataFromAPI();
      } else {
        this.client = {
          client_code: "",
          client_name: "",
          client_id: 0,
          dealers_quantity: 0
        };
      }
      this.searchCanceled();
    },

    async commercialPersonSelected(item) {
      await this.clientSelected(null);
      this.filterCommercialPerson = item;
      await this.readDataFromAPI();
    },

    async clearAutocomplete(field) {
      this.$refs[field].internalValue = [];
      switch (field) {
        case "commercialPersonAutocomplete":
          this.filterCommercialPerson = null;
          break;
      }
      await this.readDataFromAPI();
    },

    async searchCanceled() {
      this.clientShowSearch = false;
      this.clientSearchOptions = {};
    },

    async loadPivotTable(data, title) {
      this.pivot = null;

      /*Crear Pivot Table*/
      let rows = [
        { uniqueName: "distribuidor_nombre", sort: "asc" },
        { uniqueName: "cliente_nombre", sort: "asc" },
        { uniqueName: "item_factura" },
      ];

      let measures = [
        {
          uniqueName: "USD NO Liquidable",
          caption: "USD NO Liquidable",
          individual: true,
          formula: '"no_liquidable_usd"',
          aggregation: "sum",
          format: "f_importe"
        },
        {
          uniqueName: "USD Liquidable",
          caption: "USD Liquidable",
          individual: true,
          formula: '"liquidable_usd"',
          aggregation: "sum",
          format: "f_importe"
        },
      ];

      this.pivot = new WebDataRocks({
        container: "#pivot-container",
        toolbar: true,
        beforetoolbarcreated: this.customizeToolbar,
        global: {
          localization: wdrEs
        },
        report: {
          options: {
            grid: {
              type: "compact",
              showHeaders: false,
              showTotals: "on",
              showGrandTotals: "on",
              title: title
            },
            configuratorButton: false
          },
          dataSource: {
            data: data
          },
          slice: {
            rows: rows,
            columns: [{ uniqueName: "Measures" }],
            measures: measures,
            expands: {
              expandAll: false
            }
          },
          formats: [
            {
              name: "f_importe",
              thousandsSeparator: ".",
              decimalSeparator: ",",
              decimalPlaces: 2,
              currencySymbol: "",
              currencySymbolAlign: "left",
              nullValue: "",
              textAlign: "right",
              isPercent: false
            }
          ]
        }
      });
    },

    unloadPivotTable() {
      this.pivot = null;
    },

    customizeToolbar(toolbar, sr = this) {
      var tabs = toolbar.getTabs();
      tabs.forEach((tab, index) => {
        if (!(tab.id == "wdr-tab-fullscreen" || tab.id == "wdr-tab-export")) {
          delete tabs[index];
        }
      });
      toolbar.getTabs = function(
        dd = (() => {sr.DownloadDetail()})
      ) {
          tabs.unshift({
            id: "wdr-tab-download-detail",
            title: "Detallado",
            icon: this.icons.export_excel,
            handler: dd
          });
          return tabs;
      };
    },

    expandAllPivotTable() {
      this.pivot.expandAllData();
    },

    async DownloadDetail() {
      try {
        let filename =
          "comisiones_pendientes_" +
          this.$moment().format("DD/MM/YYYY h:mm a") +
          ".xlsx";

        this.loading = true;
        let endpoint =
          "/data/sale_commissions_download/" +
            /* eslint-disable */
            (this.client ? this.client.client_id.toString() : "0") +
            "/";
            /* eslint-disable */
            switch (this.filterCommercialPerson ? this.filterCommercialPerson.commercial_type_level : 0) {
              case 0:
                endpoint = endpoint + "0/0/0";
                break;
              case 1:
                /* eslint-disable */
                endpoint = endpoint + this.filterCommercialPerson.commercial_id.toString() + "/0/0";
                break;
              case 2:
                /* eslint-disable */
                endpoint = endpoint + "0/" + this.filterCommercialPerson.commercial_id.toString() + "/0";
                break;
              case 3:
                /* eslint-disable */
                endpoint = endpoint + "0/0/" + this.filterCommercialPerson.commercial_id.toString();
                break;
            }
        this.client.client_id.toString();

        // eslint-disable-next-line
        let raw = await this.$bRoot.search(endpoint, null, null, null, null);
        if (raw.data) {
          let datosWS = XLSX.utils.json_to_sheet(raw.data);
          let wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, datosWS, "datos");
          XLSX.writeFile(wb, filename);
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        this.loading = false;
      }
    }
  },

  async mounted() {
    var main_container = document.getElementById("app");
    main_container.classList.remove("home");

    try {
      this.currentLevel = this.$bRoot.auth.current_level;

      //load commercial persons
      let commercialPersons = await this.$bRoot.searchAll(
        "/data/commercial_persons_hierarchy",
        null,
        "name",
        "commercial_type_level__lt=4"
      );
      this.commercialPersonItems = commercialPersons;

      await this.readDataFromAPI();
    } catch (error) {
      if (!this.$bRoot.errors) {
        this.$bRoot.setError(error);
      }
    } finally {
      this.loading = false;
    }
  }
};
</script>
<style>
.wdr-credits {
  display: none;
}
.enabled-icon {
  pointer-events: auto;
  color: black;
}
</style>